/**
 * Created by ChrisMuto on 7/18/17.
 */

export const DID_NAVIGATE = "Auth: navigated to the login screen";
export const DID_ATTEMPT_LOGIN = "Auth: attempted login";
export const DID_AUTHENTICATE_SUCCESSFULLY = "Auth: logged in successfully";
export const DID_FAIL_AUTHENTICATION = "Auth: failed login";
export const DID_REQUEST_NEW_PASSWORD = "Auth: requested a new password";
export const DID_LOGOUT = "Auth: logged out of the app";



// WEBPACK FOOTER //
// ./src/modules/tracker/event-names/authentication-events.js